module.exports = __webpack_public_path__ + "static/media/ซองจดหมาย.89dbb00b.pdf";